import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// Organization status enum matching backend constants
const organizationStatusSchema = z.enum([
  "active",
  "onboarding",
  "pre_trial",
  "disconnected",
  "suspended",
  "trial_active",
  "qore_active",
  "trial_expired",
  "payment_required",
  "demo_org",
]);

export type OrganizationStatus = z.infer<typeof organizationStatusSchema>;

// Request schema
const updateOrgStatusRequestSchema = z.object({
  status: organizationStatusSchema,
  all_orgs: z.boolean().optional(),
  target_org: z.number().optional(),
});

// Response schema
const updateOrgStatusResponseSchema = z.object({
  org_status: z.string(),
});

export const orgStatusApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "updateOrgStatus",
    method: "put",
    path: "/application/orgstatus/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: updateOrgStatusRequestSchema,
      },
    ],
    status: 200,
    response: updateOrgStatusResponseSchema,
  }).build(),
);
